import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { listOrder, deleteOrder } from "../../actions/orderActions";
import Axios from "../../axios/axios";
import Print from "./Print";
import html2canvas from "html2canvas";
import { ListProducts } from "../../actions/productAction";
import jsPDF from "jspdf";
import { PDFViewer } from "@react-pdf/renderer";
import { PDFDownloadLink, Document, Page } from "@react-pdf/renderer";
import OrderPdf from "../Print/OrderPdf";
import { dateFormat } from "../utils/Utils";
import ConfirmationModal from "../utils/ConfirmationModal";
export default function OrderList() {
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const orderList_ = useSelector((state) => state.orderList);
  // const { orders } = orderList_;
  const [showModal, setShowModal] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [modalMessage, setModalMessage] = useState("");

  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // const [allOrders, setAllOrders] = useState([]);
  const [keyword, setKeyword] = useState("");

  // useEffect(() => {
  //   fetchOrders();
  // }, [page,keyword]);

  const fetchOrders = async () => {
    const { data } = await Axios.post(`/api/order/list`, { page, keyword });
    const filterOrders = data?.data?.filter(
      (order) =>
        order.source === "admin" || order.status === "approved" || keyword,
    );
    setOrders({ ...data, data: filterOrders });
    // setAllOrders({ ...data, data: filterOrders });
    setTotalPages(data?.pages);
    console.log(data, "aaaaaa");
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  useEffect(() => {
    dispatch(ListProducts({ pagination: false }));
  }, [dispatch]);

  const deleteHandler = (order, orderId) => {
    console.log(order);
    setModalMessage(`Are you sure you want to delete Order ID: ${orderId}?`);
    setOrderToDelete(order);
    setShowModal(true);
  };
  const confirmDelete = () => {
    console.log(orderToDelete, "orderToDelete");
    if (orderToDelete) {
      dispatch(deleteOrder(orderToDelete));
      setShowModal(false);
      setOrderToDelete(null);
      window.location.reload(); // optional, or you can refetch orders instead
    }
  };

  const search = (e) => {
    const value = e.target.value;
    setKeyword(value);
    setPage(1); // important
  };
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchOrders();
    }, 400);

    return () => clearTimeout(delay);
  }, [page, keyword]);

  const editOrder = async (id) => {
    const data = await Axios.get(`/api/order/transaction/${id}`);

    if (data.data === 1) {
      window.location.href = `/order/edit/${id}`;
    } else {
      alert("Cant edit order!");
    }
  };

  const getDelivered = (order) => {
    let result = order?.orderItems?.some((data) => data.isDelivered === false);

    return result;
  };

  const getReturn = (order) => {
    let result = order?.orderItems?.some((data) => data.isReturn === false);

    return result;
  };

  const printDocument = () => {
    const input = document.getElementById("divToPrint");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 50, 0);
      // pdf.output('dataurlnewwindow');
      pdf.save("download.pdf");
    });
  };

  const perPage = 20;
  const startIndex = (page - 1) * perPage;
  const calculateCorrectAmount = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) {
      return order?.orderAmount || 0;
    }

    const calculatedAmount = order.orderItems.reduce((total, item) => {
      const itemAmount =
        (item.prodPrice || 0) * (item.qnty || 1) * (item.days || 1);
      return total + itemAmount;
    }, 0);

    return calculatedAmount > 0 ? calculatedAmount : order?.orderAmount || 0;
  };

  const getOrderStartDate = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) return "-";

    const dates = order.orderItems
      .map((item) => item.startDate)
      .filter(Boolean)
      .map((date) => new Date(date));

    if (dates.length === 0) return "-";

    return new Date(Math.min(...dates)).toLocaleDateString();
  };

  const getOrderNoOfDays = (order) => {
    if (!order?.orderItems || order.orderItems.length === 0) return "-";

    const days = order.orderItems.map((item) => {
      if (!item.startDate || !item.endDate) return 0;

      const start = new Date(item.startDate);
      const end = new Date(item.endDate);

      const diff = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

      return diff > 0 ? diff : 0;
    });

    const maxDays = Math.max(...days);
    return maxDays > 0 ? maxDays : "-";
  };

  const getOrderTimeLeft = (order) => {
    if (!order?.orderItems?.length) return "-";

    const now = new Date();

    // All delivered items
    const deliveredItems = order.orderItems.filter((item) => item.isDelivered);

    // ❌ Nothing has been rented out yet
    if (deliveredItems.length === 0) {
      return "-";
    }

    // Items that are still with the customer
    const activeItems = deliveredItems.filter((item) => !item.isReturn);

    // ✅ Everything that was rented has been returned
    if (activeItems.length === 0) {
      return (
        <span style={{ color: "#198754", fontWeight: "bold" }}>✓ Returned</span>
      );
    }

    let nearestDiff = null;

    activeItems.forEach((item) => {
      // Skip invalid dates
      if (!item.deliveredAt) return;

      const delivered = new Date(item.deliveredAt);

      const dueDate = new Date(
        delivered.getTime() + (item.days || 1) * 24 * 60 * 60 * 1000,
      );

      const diff = dueDate.getTime() - now.getTime();

      if (nearestDiff === null || Math.abs(diff) < Math.abs(nearestDiff)) {
        nearestDiff = diff;
      }
    });

    // Safety check
    if (nearestDiff === null) {
      return "-";
    }

    const totalMinutes = Math.floor(Math.abs(nearestDiff) / (1000 * 60));

    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    const text = `${days > 0 ? `${days}d ` : ""}${hours}h ${minutes}m`;

    if (nearestDiff >= 0) {
      return (
        <span style={{ color: "#198754", fontWeight: "bold" }}>
          🟢 {text} left
        </span>
      );
    }

    return (
      <span style={{ color: "#dc3545", fontWeight: "bold" }}>
        🔴 {text} overdue
      </span>
    );
  };

  return (
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="p-2">
                {" "}
                <h4 class="card-title">Orders </h4>
              </div>

              <div class="ml-auto p-2">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by Order ID,Phone Number Or Customer Name"
                  onChange={search}
                  style={{
                    width: "330px",
                  }}
                />
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Orderd Date</th>
                    <th>Order Id</th>
                    <th>Customer Name</th>
                    <th>Work Date</th>
                    <th>No of Days</th>
                    <th>Delivered</th>
                    <th>Time Left</th>
                    <th>Return</th>
                    <th>Amount</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.data?.length > 0 ? (
                    orders?.data?.map((order, index) => (
                      <tr>
                        <td>{startIndex + index + 1}</td>
                        <td>
                          {/* Only show date in your dateFormat */}
                          {new Date(order?.createdAt).toLocaleDateString()}{" "}
                          <br />
                          {/* Show time separately */}
                          <small>
                            {new Date(order?.createdAt).toLocaleTimeString()}
                          </small>
                        </td>

                        <td>
                          <Link to={`/order/${order._id}`}>
                            ADC_{order?.orderId}
                          </Link>
                        </td>
                        <td>
                          <b>{order?.user?.name}</b> <br />
                          <small>{order?.user?.phone}</small>
                        </td>
                        <td>{getOrderStartDate(order)}</td>
                        <td>{getOrderNoOfDays(order)}</td>
                        <td>
                          {getDelivered(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: "20px" }}
                            ></i>
                          ) : (
                            "No"
                          )}
                        </td>

                        <td>{getOrderTimeLeft(order)}</td>
                        <td>
                          {" "}
                          {getReturn(order) === false ? (
                            <i
                              class="icon-check menu-icon"
                              style={{ fontSize: "20px" }}
                            ></i>
                          ) : (
                            "No"
                          )}
                        </td>
                        <td>
                          <b>
                            ₹ {Number(calculateCorrectAmount(order)).toFixed(2)}
                          </b>
                        </td>
                        <td>
                          {console.log("PDF ORDER ITEMS", order.orderItems)}
                          <div class="d-flex align-items-center">
                            <PDFDownloadLink
                              document={
                                <OrderPdf
                                  products={products}
                                  customerName={order?.user?.name}
                                  customerNumber={order?.user?.phone}
                                  address={order?.user?.address1}
                                  invoiceId={order?.orderId}
                                  orderDate={order.createdAt}
                                  advance={order?.totalReceive}
                                  amount={order?.orderAmount}
                                  items={order?.orderItems}
                                  orderitemdate={order?.orderItems}
                                  discount={order?.discount}
                                  orderQr={order?.qrCode}
                                />
                              }
                              fileName={`${order?.user?.name}-order.pdf`}
                            >
                              {({ blob, url, loading, error }) => (
                                <button
                                  type="button"
                                  class="btn btn-outline-primary btn-sm"
                                >
                                  print
                                </button>
                              )}
                            </PDFDownloadLink>

                            {!order.isRentOutInit && (
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm ms-2"
                                onClick={() =>
                                  deleteHandler(order?._id, order?.orderId)
                                }
                              >
                                Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No results found for "{keyword}"</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div style={{ marginTop: "20px" }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                  disabled={page === 1}
                >
                  Previous
                </button>

                <span style={{ margin: "0 10px" }}>
                  Page {page} of {totalPages}
                </span>

                <button
                  className="btn btn-primary"
                  onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
                  disabled={page === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="exampleModalPrint"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        backdrop={true}
        data-backdrop="static"
      >
        {" "}
        <form class="forms-sample">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  {/* {orderResponse ? orderResponse : 'Summary'} */}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body" id="divToPrint"></div>

              <div class="modal-footer">
                <a href="/orders">
                  <button type="button" class="btn btn-secondary">
                    Close
                  </button>
                </a>

                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={printDocument}
                >
                  download pdf
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        message={modalMessage}
      />
    </div>
  );
}
